import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"

import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

    const Notifications = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [notifications, setNotifications] = useState([])
        const [isLoading, setIsLoading] = useState(false)
        const [areas, setAreas] = useState([])

        
        const [statusOptions, setStatusOptions] = useState(['Pending Approval','Rejected','Approved'])
        const [userList, setUserList] = useState([])
        const [sSenderId, setSSenderId] = useState('')
        const [sDocumentNo, setSDocumentNo] = useState('')
        const [sStatus, setSStatus]     = useState('Pending Approval')
        const [userId, setUserId]       = useState('')
        const [userName, setUserName]   = useState('')

       
        const fetchData = () => {
          handleFilterData()
          const data = {
            id    :"",
            name  :"",
            title :"",
            dept  :"",
            category:"",
            area  : ""
          }
          axios.post(url.USERSFILTER, JSON.stringify(data), Config).then((r)=>{ 
            setUserList(r.data)
          }).catch((e)=>{  
            console.log(e); 
          });
 
          const obj = JSON.parse(localStorage.getItem("authWTUser"));
          setUserId(obj.id)
          setUserName(obj.username)
        }
        
        useEffect(() => {
          fetchData();
        },[]);

        const handleFilterData = () =>{
          const obj = JSON.parse(localStorage.getItem("authWTUser"));
          const data = { userId:obj.id }
          setIsLoading(true)
          axios.post(`${url.DASHNOTIFICATIONS}`, JSON.stringify(data), Config).then((r)=>{ 
            setNotifications(r.data)
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        const handleClearSearch = () =>{
          setSDocumentNo('')
          setSSenderId('')
          setSStatus('Pending Approval')
          handleFilterData()
        }

        const columns = [

        {
            dataField: 'date',
            text: 'Date',
            sort: true
        },
        {
          dataField: 'type',
          text: 'Type',
          sort: true
      },
      {
        dataField: 'ref',
        text: 'Ref',
        sort: true
      },
        {
            dataField: 'details',
            text: 'Details',
            sort: true
        },
        {
            dataField: 'status',
            text: 'Status',
            sort: true,
            formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'date',
          order: 'desc'
        }];

        function noFormatter(cellContent, row){
          return(
            <strong>{cellContent}</strong>
          )
        }
        function actionFormatter(cellContent, row){
          return(
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={()=>{ 
                    if((row.type == 'Work order') || row.type == 'Workorder'){
                      history.push(`/WorkOrder-Details/${be.encryptId(row.id)}`)
                    }else if(row.type == 'Complaint'){
                      history.push(`/Customer-Complaint-Details/${be.encryptId(row.id)}`)
                    }else if(row.type == 'WQ Sample'){
                      history.push(`/Water-Quality-Details/${be.encryptId(row.id)}`)
                    }else if(row.type == 'Production'){
                      history.push(`/Water-Production-Details/${be.encryptId(row.id)}`)
                    }else if(row.type == 'Leave Plan'){
                      history.push(`/leave-plan-details/${be.encryptId(row.id)}`)
                    }else if(row.type == 'Leave'){
                      history.push(`/leave-details/${be.encryptId(row.id)}`)
                    }else{
                      toastr.error('Selected document notification not set')
                    }
                     
                  }}
                >
                  Details
            </Button>
          )
        }
        function statusFormatter(cellContent, row) {
          if(row.status == "Pending Approval"){
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-warning">{ cellContent }</Badge>
              </div>
            );
          }
            
  
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Notifications | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                     
                        <Row>
                                      
                            <Col lg="12">
                           
                              <Card>
                              <h5 className="card-header bg-transparent border-bottom text-uppercase">Notifications</h5>
                                <CardBody>

                                                  
                                            
                                {(notifications.length > 0) && (

                                    
                                    <ToolkitProvider
                                      keyField="id"
                                      data={notifications}
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={notifications} 
                                                  columns={ columns } 
                                                  striped={ true }
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  noDataIndication="No Records" 
                                                  
                                                    {...toolkitProps.baseProps}
                                               
                                                  />
                                                </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    {notifications && (notifications.length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>All Cleared</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                    
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Notifications;